import React, { useCallback } from "react";
import { Radio as MaterialRadio } from "@material-ui/core";
import { Text } from "components/commons";
import styles from "./radio.module.scss";
import classNames from "classnames";

const Radio = ({
  className,
  radioClassName,
  options,
  value,
  onChange,
  name,
  vertical,
  disabled,
}) => {
  const onChangeCb = useCallback(
    (val) => {
      if (onChange) return onChange(name, { value: val });
    },
    [onChange, name]
  );

  return (
    <div
      className={classNames(styles.radioContainer, { [`${styles.vertical}`]: vertical }, className)}
    >
      {options.map((o, i) => {
        return (
          <div
            key={i}
            className={classNames(styles.radio, radioClassName, {
              [`${styles.disabled}`]: disabled,
            })}
          >
            <MaterialRadio
              checked={value === o.value}
              value={o.value}
              onChange={() => {
                onChangeCb(o.value);
              }}
              disabled={disabled}
            ></MaterialRadio>
            <Text>{o.text}</Text>
          </div>
        );
      })}
    </div>
  );
};

export default Radio;
